'use strict';

module.exports = require('nmr-simulation');
